var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimezone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.b,.c{stroke:#455079;stroke-width:1.5px;}.b{stroke-miterlimit:10;}.c{stroke-linecap:round;stroke-linejoin:round;}"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1272, -1246)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(1272 1246)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25974, 0, 0, 1.25974, 1268.142822, 1242.142822)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,18a7,7,0,1,0-7-7A7,7,0,0,0,11,18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.683,12H16.875",
    transform: "translate(0.221 -3.333)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.684,20H16.875",
    transform: "translate(0.221 -6.667)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.34,18.021c1.292,0,2.34-3.067,2.34-6.849s-1.048-6.849-2.34-6.849S11,7.389,11,11.172,12.048,18.021,13.34,18.021Z",
    transform: "translate(-2.34 -0.171)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezone);
export default __webpack_public_path__ + "static/media/timezone.8dd9428afa2848913147c98419fc447e.svg";
export { ForwardRef as ReactComponent };